import { VIDEO_CARD_LOADED, VIDEO_CARD_RESET } from 'reducers/actions-types';

export default Object.freeze({
    reset() {
        return { type: VIDEO_CARD_RESET };
    },
    onLoaded() {
        return { type: VIDEO_CARD_LOADED };
    },
});



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/reducers/modules/video-cards/actions.js